import { commonBlotterApiConnector } from 'apiConnector/blotters/common';
import type { BlotterItemDetails } from 'models/blotters/BlotterItemDetails';
import type { BlotterType } from 'models/blotters/BlotterType';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  blotterPanelItemDetailsFetched,
  blotterPanelItemDetailsFetchFailed,
} from 'state/blotters/blotterPanel/blotterPanel.action';
import type { EpicWithThunk } from 'state/state.common';

export interface DlpProductTradeId {
  productIsin: string;
  tradeReference: string;
}
export interface FetchBlotterItemDetailsEpicApi {
  getItemDetails(id: string, blotterType: BlotterType): Observable<BlotterItemDetails>;
  getDlpProductTradesDetails(productId: string, tradeReference: string): Observable<BlotterItemDetails>;
}

export function blotterPanelItemDetailsRequestedEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('BLOTTER_PANEL_ITEM_DETAILS_REQUESTED'),
      switchMap(({ id, blotterType }) => {
        const connector = commonBlotterApiConnector(httpClient);
        let detail$ = connector.getItemDetails(id as string, blotterType);
        if (blotterType === 'dlpProductTrades') {
          const productTradesId = id as DlpProductTradeId;
          detail$ = connector.getDlpProductTradesDetails(productTradesId.productIsin, productTradesId.tradeReference);
        }
        return detail$.pipe(
          map(response => blotterPanelItemDetailsFetched(id, blotterType, response)),
          catchError(err => {
            return of(
              blotterPanelItemDetailsFetchFailed(
                id,
                blotterType,
                {
                  actions: [],
                  documents: { docs: [] },
                  isObsolete: false,
                  isFetchingError: true,
                },
                err.payload,
              ),
            );
          }),
        );
      }),
    );
}
